import { render, staticRenderFns } from "./SubPageSelector.vue?vue&type=template&id=c13ca794&scoped=true&"
import script from "./SubPageSelector.vue?vue&type=script&lang=js&"
export * from "./SubPageSelector.vue?vue&type=script&lang=js&"
import style0 from "./SubPageSelector.vue?vue&type=style&index=0&id=c13ca794&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13ca794",
  null
  
)

export default component.exports